import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31d86400"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header__logo" }
const _hoisted_3 = ["onMouseenter", "onFocusin", "onFocusout", "onMouseleave"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "container" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Main menu ")
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_9 = { class: "submenu__list" }
const _hoisted_10 = {
  key: 0,
  class: "btn btn--primary"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hamburger-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hamburger-inner" })
], -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_logo = _resolveComponent("icon-logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_icon_submenu_show = _resolveComponent("icon-submenu-show")!
  const _component_icon_submenu_hide = _resolveComponent("icon-submenu-hide")!
  const _component_icon_arrow_link = _resolveComponent("icon-arrow-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", {
      up: _ctx.scrollUp,
      'header--active': _ctx.mobileMenuVisible,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {
            _ctx.hideSubmenuAfterClick();
            this.mobileMenuVisible = false;
          })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_icon_logo)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("nav", {
        class: _normalizeClass(["nav-primary", {
          'is-active': _ctx.mobileMenuVisible,
          'nav-primary--submenu': _ctx.submenuMobileVisible !== null,
        }])
      }, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.text,
              class: _normalizeClass({
              'has-submenu': item.submenu,
              'has-submenu--active': _ctx.submenuMobileVisible === index,
            }),
              onMouseenter: ($event: any) => (item.submenu && _ctx.showSubmenuDesktop(index)),
              onFocusin: ($event: any) => (item.submenu && _ctx.showSubmenuDesktop(index)),
              onFocusout: ($event: any) => (item.submenu && _ctx.hideSubmenuDesktop()),
              onMouseleave: ($event: any) => (item.submenu && _ctx.hideSubmenuDesktop())
            }, [
              (item.submenu)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["submenu__trigger", {
                  'submenu__trigger--inactive': _ctx.submenuMobileVisible === index,
                }]),
                      onClick: ($event: any) => (_ctx.toggleSubmenuMobile(index))
                    }, null, 10, _hoisted_4),
                    _createVNode(_component_router_link, {
                      to: item.to,
                      class: _normalizeClass({
                  'router-link-active': _ctx.$route.path.startsWith(item.to),
                })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.text) + " ", 1),
                        _createVNode(_component_icon_submenu_show)
                      ]),
                      _: 2
                    }, 1032, ["to", "class"]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["submenu", {
                  'is-active':
                    _ctx.submenuVisible === index || _ctx.submenuMobileVisible === index,
                }])
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("button", {
                          class: "submenu__back",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideSubmenuMobile()))
                        }, [
                          _createVNode(_component_icon_submenu_hide),
                          _hoisted_6
                        ]),
                        _createVNode(_component_router_link, {
                          class: "submenu__header",
                          to: item.to,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => {
                      _ctx.toggleMenu();
                      _ctx.hideSubmenuAfterClick();
                    })
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", {
                                innerHTML: item.header
                              }, null, 8, _hoisted_7),
                              _hoisted_8,
                              _createVNode(_component_icon_arrow_link)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.submenu, (submenuItem) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: submenuItem.text,
                                class: _normalizeClass({ submenu__archive: submenuItem.isArchive })
                              }, [
                                _createVNode(_component_router_link, {
                                  to: submenuItem.to,
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => {
                            _ctx.toggleMenu();
                            _ctx.hideSubmenuAfterClick();
                          })
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(submenuItem.text), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ], 2))
                            }), 128))
                          ])
                        ])
                      ])
                    ], 2)
                  ], 64))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: item.to,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleMenu()))
                  }, {
                    default: _withCtx(() => [
                      (item.isButton)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.text), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.text), 1))
                    ]),
                    _: 2
                  }, 1032, ["to"]))
            ], 42, _hoisted_3))
          }), 128))
        ])
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass(["hamburger", { 'is-active': this.mobileMenuVisible }]),
        "aria-label": "Menu",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleMenu()))
      }, _hoisted_13, 2)
    ])
  ], 2))
}